import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ContextsProvider } from './contexts/ContextsContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PublicRoute } from './components/auth/PublicRoute';
import Layout from './components/Layout/Layout';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import TelegramLoginPage from './pages/TelegramLoginPage';
import DashboardPage from './pages/DashboardPage';
import TransactionsPage from './pages/TransactionsPage';
import ContextsPage from './pages/ContextsPage';
import InvitationPage from './pages/InvitationPage';
import PlanningPage from './pages/PlanningPage';
import GoalPage from './pages/GoalPage';
import SettingsPage from './pages/SettingsPage';
import TelegramSettingsPage from './pages/TelegramSettingsPage';
import LegalPage from './pages/LegalPage';
import { privacyPolicy } from './legal/privacyPolicy';
import { termsOfUse } from './legal/termsOfUse';
import './i18n'; // Initialize i18n

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ContextsProvider>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Routes>
          {/* Public routes */}
          <Route
            path="/"
            element={
              <PublicRoute>
                <LandingPage />
              </PublicRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          {/* The Telegram bot's one-time link: works signed in or out, and
              always ends in the session the link belongs to. */}
          <Route path="/entrar/telegram" element={<TelegramLoginPage />} />
          {/* The privacy policy and the terms: open to everyone, signed in or out. */}
          <Route
            path="/privacidade"
            element={<LegalPage document={privacyPolicy} other={{ to: '/termos', label: termsOfUse.title }} />}
          />
          <Route
            path="/termos"
            element={<LegalPage document={termsOfUse} other={{ to: '/privacidade', label: privacyPolicy.title }} />}
          />
          
          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/transactions"
            element={
              <ProtectedRoute>
                <Layout>
                  <TransactionsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contexts"
            element={
              <ProtectedRoute>
                <Layout>
                  <ContextsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/planning"
            element={
              <ProtectedRoute>
                <Layout>
                  <PlanningPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/planning/goals/:goalId"
            element={
              <ProtectedRoute>
                <Layout>
                  <GoalPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <SettingsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/telegram"
            element={
              <ProtectedRoute>
                <Layout>
                  <TelegramSettingsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* An invitation link: signed out it shows what it is for and the
              way in; signed in it takes the invitation up. */}
          <Route path="/invitations/:token" element={<InvitationPage />} />

          {/* Fallback routes */}
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Box>
        </ContextsProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;